import { flow, getParent, types } from 'mobx-state-tree';
import { when } from 'mobx';
import Strategies from '../../stores/DiscoveryStore/Strategies';

const ListParams = types
  .model('ListParams', {
    discoveryStrategy: types.optional(Strategies, {}),
    skipVeroValidation: true,
    useRangedStrategy: false,
  })
  .views(self => ({
    get paramsValid() {
      return !!self.discoveryStrategy;
    },
    get transport5007() {
      return getParent(self).transport5007;
    },
    get markets() {
      return getParent(self, 2).settingsStore.markets;
    },
  }))
  .actions(self => ({
    afterAttach() {
      when(() => self.markets.sellersAccounts.length, () => self.fetchPricingList());
      self.discoveryStrategy.properties = {
        profit: 0,
        breakEven: 0,
        profitType: 1,
        strategyType: '1',
      };
    },
    fetchPricingList: flow(function* fetchPricingList() {
      try {
        const { data } = yield self.transport5007.fetch(
          `strategy/v1/Strategies?sourceMarketplaceId=CATALOG`,
          {},
          { 'Seller-Account-Id': self.markets.sellersAccounts[0].id },
        );
        self.discoveryStrategy.properties = {
          profit: data.fixedProfit.profit,
          breakEven: data.fixedProfit.breakEven,
          profitType: data.fixedProfit.inPercents ? 1 : 2,
          strategyType: '1',
        };
      } catch (err) {
        console.log('get pricing list failed: ', err);
      }
    }),
    setDiscoveryStrategy(val) {
      self.discoveryStrategy = val;
    },
    setSkipVeroValidation(val) {
      self.skipVeroValidation = val;
    },
    setUseRangedStrategy(val) {
      self.useRangedStrategy = val;
    },
    resetValues() {
      self.discoveryStrategy.properties = {
        profit: 5,
        breakEven: 44,
        profitType: 1,
        strategyType: '1',
      };
      self.useRangedStrategy = false;
    },
  }));

export default ListParams;
